/** Public information for the current free pilot; billing documents are tracked in TODO-LEGAL.md. */
export const LEGAL_PAGES = ["terms", "privacy", "cookies", "contact"] as const;
export type LegalPageId = (typeof LEGAL_PAGES)[number];
export type LegalDocument = {
  title: string;
  lead: string;
  summary: string[];
  sections: { heading: string; paragraphs: string[]; links?: { label: string; href: string }[] }[];
};
export type LegalCopy = {
  updated: string;
  navigation: string;
  summaryTitle: string;
  contact: string;
  loginNote: string;
  loginPrivacy: string;
  freePilot: string;
  /** Footer once a real provider sells in its live environment (reviews/06-action-plan.md 3.6). */
  sellingLive: string;
  pages: Record<LegalPageId, LegalDocument>;
};
